<template>
  <el-form-item :label="label"
                class="app-regions-select">
    <el-select :value="value"
               @input="emit"
               multiple>
      <el-option :key="`region_${region.key}`"
                 :label="region.label"
                 :value="region.key"
                 v-for="region in regions">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'AppRegionsSelect',
  props: {
    label: {
      type: String,
      default: ''
    },
    regions: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  methods: {
    emit (value) {
      this.$emit('input', value)
    }
  }
}
</script>
